export function useSite() {
  const site = useState<any>("site", () => null);

  // Exposed so the shared building-blocks library (which reads `siteId`) works
  // identically in both apps. Admin derives `siteId` from the route; here it is
  // derived from the active site state.
  const siteId = computed<string | undefined>(() => site.value?.id);

  return {
    site,
    siteId,
  };
}
